module.exports = __webpack_public_path__ + "img/lounge.164564bd.jpeg";